import { useEffect, useState } from "react";
import { Input } from "../../../../../Input/Input";
import DefaultModalLayout from "../../../../../Modal/DefaultModalLayout";
import { ModalRowContentContainer } from "../../../../AlimTalk/AlimTalkModal";
import { ModalRow } from "../../../../Users/UserDetail/BlackListModal/BlackListModal";
import { DefaultModalCommonProps } from "../../../../Users/UserDetail/CommentModal/CommentModal";
import { ModalLabel } from "../../../../Users/UserDetail/CommentModal/TargetContainer";
import styled from "styled-components";
import { useApi } from "../../../../../../hooks/useApi";
import { toast } from "react-toastify";
import Loader from "../../../../../DefaultStyles/Loader";
import {
  GetServiceSetData,
  GetSubscriptionSetData,
} from "../../../../../../ApiTS/ServiceDatasTS";
import RadioBtn from "../../../../../Button/RadioBtn";
import { MATCHMAKING_SUBS_LIST } from "../../../../../../AdminApi/commFunc";
import { useRecoilValue } from "recoil";
import { authType } from "../../../../../../pages/Login";
import Flex from "../../../../../DefaultStyles/Flex";
import AlertModal from "../../../../../Modal/AlertModal";
import { encryptPW } from "../../../../../../Api/ApiCommon";
import DropDown, { OptionType } from "../../../../../Filters/DropDown";
import domain_list from "../../../../../../datafiles/emaillist_domain.json";
import {
  getString3ByKey,
  getSubsNameBySubsId3,
} from "../../../../../../AdminApi/3.0_utils";
import {
  GetServiceSetData_V3,
  GetSubscriptionSetData_V3,
} from "../../../../../../ApiTS/ServiceDatasTS_V3";

interface MatchMakingEmailInputModalProps extends DefaultModalCommonProps {
  refetch: () => void;
}

export default function MatchMakingEmailInputModal({
  closeEvent,
  refetch,
}: MatchMakingEmailInputModalProps) {
  const auth = useRecoilValue(authType);
  const [domain, setDomain] = useState<OptionType>({
    value: "",
    label: "선택",
  });
  const [id, setId] = useState("");
  const [addEmail, setAddEmail] = useState(false);
  const [subsIdCheck, setSubsIdCheck] = useState<{ [key: number]: boolean }>(
    {}
  );
  const [subsPw, setSubsPw] = useState<{ [key: number]: string }>({});
  const [subsIdList, setSubsIdList] = useState<
    { servsubsid: number; password: string }[]
  >([]);

  console.log(subsIdCheck, subsPw);
  const [duplicateModal, setDuplicateModal] = useState(false);
  const [notValidList, setNotValidList] = useState("");
  let domainList: OptionType[] = [];

  // let domainList = domain_list.map((d) => {
  //   return {
  //     value: d.PRTEM_DOMAIN,
  //     label: d.PRTEM_DOMAIN,
  //   };
  // });

  domainList.push({
    value: "linkidmail.com",
    label: "linkidmail.com",
  });

  domainList.push({
    value: "acecute.com",
    label: "acecute.com",
  });

  const { response, error, loading } = useApi({
    method: "post",
    url: addEmail && subsIdList?.length > 0 ? "matchParty/email" : undefined,
    data: {
      list: subsIdList,
      email: `${id}@${domain.value}`,
      state: 1,
    },
  });

  useEffect(() => {
    if (response?.status === 201) {
      if (response?.data?.result === 0) {
        toast.success("매치메이킹 이메일 생성 완료");
        closeEvent();
        refetch();
      } else if (response?.data?.result > 0) {
        setDuplicateModal(true);

        if (response?.data?.notValidServiceList) {
          const emailNameList: string[] = [];

          response?.data?.notValidServiceList?.forEach(
            (f: { servsubsid: number; id: number }) => {
              const subsData = GetSubscriptionSetData_V3(f?.servsubsid);
              const svcData = GetServiceSetData_V3(subsData?.SVC_ID ?? 0);

              emailNameList.push(
                `${getString3ByKey(Number(svcData?.SVC_NM)) ?? ""}_${f?.id}`
              );
            }
          );

          setNotValidList(emailNameList?.join(", "));
        }
      }
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "이메일 생성에 실패하였습니다.");
    }
  }, [error]);

  useEffect(() => {
    let obj: {
      [key: number]: boolean;
    } = {};

    MATCHMAKING_SUBS_LIST?.forEach((s) => {
      obj[s] = false;
    });

    setSubsIdCheck(obj);
  }, []);

  return (
    <>
      <DefaultModalLayout
        modalTitle="매치메이킹 이메일 추가111"
        closeEvent={() => closeEvent()}
        confirmEvent={() => {
          const output = Object.entries(subsPw)?.map(([key, value]) => ({
            servsubsid: +key,
            password: encryptPW(
              {
                pw: value,
                ...(key === "3000" ? { adltPw: "1234" } : {}),
              },
              key === "31000" || key === "33000" ? 3 : 1
            ),
          }));

          console.log(output);

          setSubsIdList(output);

          setAddEmail(true);
        }}
        confirmBtnText="이메일 생성"
        cancelBtnText="취소"
        confirmDisabled={
          domain.value === "" ||
          id === "" ||
          Object.keys(subsPw)?.length !==
            Object.values(subsIdCheck)?.filter((c) => c === true)?.length
        }
      >
        <ModalRow style={{ alignItems: "flex-start" }}>
          <ModalLabel>아이디 설정</ModalLabel>

          <ModalRowContentContainer style={{ alignItems: "flex-start" }}>
            <div>
              <Input
                value={id}
                onChange={(e) => setId(e.target.value)}
                placeholder="아이디 입력"
              />
            </div>

            <DropDown
              dropdownValue={domain}
              setDropDownValue={setDomain}
              optionList={domainList}
              boxWidth={140}
            />
          </ModalRowContentContainer>
        </ModalRow>

        <ModalRow style={{ alignItems: "flex-start" }}>
          <ModalLabel>Subsription</ModalLabel>

          <ModalRowContentContainer
            style={{ alignItems: "flex-start", flexDirection: "column" }}
          >
            {MATCHMAKING_SUBS_LIST?.map((s) => {
              return (
                <Flex key={s} gapSize={10}>
                  <div style={{ width: 168 }}>
                    <RadioBtn
                      label={`${s}_${getSubsNameBySubsId3(+s ?? 0)}`}
                      clickEvent={() =>
                        setSubsIdCheck((prev) => ({
                          ...prev,
                          [s]: !prev[s],
                        }))
                      }
                      check={subsIdCheck[s]}
                      noTooltip={true}
                      sHeight={38}
                    />
                  </div>

                  <Input
                    style={{ width: "calc(100% - 168px - 10px)" }}
                    placeholder="비밀번호 입력"
                    value={subsPw[s]}
                    disabled={!subsIdCheck[s]}
                    onChange={(e) =>
                      setSubsPw((prev) => ({
                        ...prev,
                        [s]: e.target.value,
                      }))
                    }
                  />
                </Flex>
              );
            })}
          </ModalRowContentContainer>
        </ModalRow>
      </DefaultModalLayout>

      {loading && <Loader />}

      {duplicateModal && (
        <AlertModal
          title={"이미 사용 중인 이메일입니다."}
          desc={
            notValidList !== "" ? `사용 중인 계정: ${notValidList}` : undefined
          }
          confirmText="재설정하기"
          confirmEvent={() => {
            setDuplicateModal(false);
            setNotValidList("");
            setAddEmail(false);
          }}
          cancelEvent={() => closeEvent()}
        />
      )}
    </>
  );
}

const Domain = styled.span`
  height: 38px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  text-align: left;
  color: #1e1e1e;
`;
